export default __webpack_public_path__ + "static/media/ep2collage6.58e39259.jpg";